import React from 'react';
import './empty.scss';
import '././content.scss';
const EmptyCard = () => {
  return (<>
    <div className="athm-card">
      <div className="athm-card-thumb43">
        <div className="athm-card-thumb43__assist"></div>
        <div className="athm-card-thumb43__caption"></div>
        <div className="athm-card-unit-information">
          <div className="athm-card-unit-information__item athm-card-unit-information__item--right"></div>
          <div className="athm-card-unit-information__assist">
            <span className="athm-card-unit-information__item"></span>
          </div>
        </div>
      </div>
    </div>
    <div className="athm-card">
      <div className="athm-card-full169">
        <div className="athm-card-full169__caption"></div>
        <div className="athm-card-full169__assist">
          <div className="athm-card-full169__time"></div>
        </div>
        <div className="athm-card-unit-information">
          <div className="athm-card-unit-information__item athm-card-unit-information__item--right"></div>
          <div className="athm-card-unit-information__assist">
            <span className="athm-card-unit-information__item"></span>
          </div>
        </div>
      </div>
    </div>
  </>)
}
const Empty = ({card}) => {
  return (
    card ? <div className="empty"><EmptyCard /></div> :
    <div className="empty">
      <div className="header">
        <div className="header__title">车系名称</div>
      </div>
      <section className="content__box">
        <div className="content__tab">
          <div className="activate">新车探馆</div>
          <div>车展体验</div>
        </div>
        <EmptyCard />
      </section>
    </div>
  )
}

export default Empty;